import { FloatingOverlay } from '@floating-ui/react';
import styled, { css } from 'styled-components';
import { StyledDialogContentProps } from './types';
import { Theme, baseContainer } from '@redsift/design-system';

/**
 * Component style.
 */
export const StyledDialogContent = styled.div<StyledDialogContentProps>`
  ${baseContainer}
  ${({ $theme }) => css`
    color: var(--redsift-color-neutral-${$theme === Theme.dark ? 'white' : 'x-dark-grey'});
    background-color: var(--redsift-color-neutral-${$theme === Theme.dark ? 'black' : 'white'});
  `}

  border-radius: 4px;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2);
  display: flex;
  filter: drop-shadow(0px 4px 5px rgba(0, 0, 0, 0.14)) drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.12));
  flex-direction: column;
  font-family: var(--redsift-typography-dialog-font-family);
  font-size: var(--redsift-typography-dialog-font-size);
  font-weight: var(--redsift-typography-dialog-font-weight);
  line-height: var(--redsift-typography-dialog-line-height);
  margin: 32px;
  max-width: calc(100vw - 48px);
  padding: 24px;
  width: 540px;
  z-index: var(--redsift-layout-z-index-dialog);

  ${({ $width, $maxWidth, $minWidth }) => css`
    ${$width !== undefined ? `width: ${$width};` : ''}
    ${$maxWidth !== undefined ? `min-width: ${$maxWidth};` : ''}
    ${$minWidth !== undefined ? `max-width: ${$minWidth};` : ''}
  `}

  &:focus-visible {
    outline: none;
  }

  .redsift-dialog-content__header {
    align-items: flex-start;
    display: flex;
    justify-content: space-between;
  }

  .redsift-card-header__icon-button {
    margin-top: 8px;
    margin-left: auto;
    margin-right: 8px;

    [dir='rtl'] & {
      margin-left: 8px;
      margin-right: auto;
    }
  }
`;

export const StyledFloatingOverlay = styled(FloatingOverlay)`
  background: rgba(0, 0, 0, 0.8);
  display: grid;
  place-items: center;
  z-index: var(--redsift-layout-z-index-overlay);
`;
